import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core'
import { UntypedFormBuilder, Validators } from '@angular/forms'
import { ActivatedRoute } from '@angular/router'
import { Subscription } from 'rxjs'
import { finalize } from 'rxjs/operators'
import { ApiService } from 'src/app/services/api.service'
import { UiService } from 'src/app/services/ui.service'
import { confirmMatchingFormFields } from 'src/app/shared/validators'
import { minPasswordLength } from 'src/utils/aws-utils'
import { handleArpioError } from 'src/utils/handle-error'
import { subscriptionActive } from 'src/utils/rxjs-utils'

@Component({
  selector: 'app-finish-reset-password',
  templateUrl: './finish-reset-password.component.html',
  styleUrls: ['./finish-reset-password.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class FinishResetPasswordComponent implements OnInit {
  invalidContext = false

  private resetSuccessful = false
  private resetSubscription: Subscription = null

  private resetPasswordFormModel = this.formBuilder.group(
    {
      password: ['', [Validators.required, Validators.minLength(minPasswordLength)]],
      confirmPassword: ['', [Validators.required]],
    },
    {
      validators: confirmMatchingFormFields('password', 'confirmPassword'),
    }
  )
  private userEmail: string = null
  private passwordResetToken: string = null

  constructor(
    private formBuilder: UntypedFormBuilder,
    private apiService: ApiService,
    private uiService: UiService,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    if (!this.route.snapshot.queryParamMap.has('passwordResetToken')) {
      this.invalidContext = true
    } else {
      this.passwordResetToken = this.route.snapshot.queryParamMap.get('passwordResetToken')
      this.apiService
        .previewResetPassword(this.passwordResetToken)
        .subscribe(
          (userDto) => (this.userEmail = userDto.email),
          handleArpioError(window.location.href, this.apiService, this.uiService)
        )
    }
  }

  private get resetButtonEnabled() {
    return this.resetPasswordFormModel.valid && !this.invalidContext && !this.resetInProgress && !this.resetSuccessful
  }

  private resetPassword() {
    this.resetSubscription = this.apiService
      .finishResetPassword(this.passwordResetToken, this.resetPasswordFormModel.value.password)
      .pipe(finalize(() => (this.resetSubscription = null)))
      .subscribe(
        () => (this.resetSuccessful = true),
        handleArpioError(window.location.href, this.apiService, this.uiService)
      )
  }

  get passwordError(): string {
    let passwordLength = this.resetPasswordFormModel.value.password.length
    if (passwordLength > 2 && passwordLength < minPasswordLength) {
      return 'Too short'
    }
    return null
  }

  get confirmPasswordError(): string {
    let confirmPasswordLength = this.resetPasswordFormModel.value.confirmPassword.length
    if (
      confirmPasswordLength > 5 &&
      this.resetPasswordFormModel.value.password !== this.resetPasswordFormModel.value.confirmPassword
    ) {
      return "Doesn't Match"
    }
    return null
  }

  get resetInProgress() {
    return subscriptionActive(this.resetSubscription)
  }
}
